// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__eXY4a","box":"WorkspacesBox_box__W5kQ1","node":"WorkspacesBox_node__1HIkW"};